import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import "../../../6729.css";

import image1 from "../../../images/motorcycle/motor-oil/6208/pictures_FF6208_1_green_front_1200_2.jpg";
import image2 from "../../../images/motorcycle/motor-oil/6208/pictures_FF6208-1_green_back_1200.jpg";

import image3 from "../../../images/motorcycle/motor-oil/6208/pictures_FF6208-20_green_front_1200.jpg";
import image6 from "../../../images/motorcycle/motor-oil/6208/pictures_FF6208-20_green_back_1200.jpg";

import image4 from "../../../images/motorcycle/motor-oil/6208/pictures_FF6208_60_green_front_1200_1.jpg";
import image7 from "../../../images/motorcycle/motor-oil/6208/pictures_FF6208-60_green_back_1200.jpg";

import image5 from "../../../images/motorcycle/motor-oil/6208/pictures_FF6208_DR_green_front_1200.jpg";
import image8 from "../../../images/motorcycle/motor-oil/6208/pictures_FF6208-DR_green_back_1200.jpg";

import image9 from "../../../images/motorcycle/motor-oil/6208/pictures_FF6208_IBC_white_front_1200.jpg";
import image10 from "../../../images/motorcycle/motor-oil/6208/pictures_FF6208-IBC_white_back_1200.jpg";


const images = [
    { src: image1, alt: "Front" },
    { src: image3, alt: "Back" },
    { src: image4, alt: "Front 4L" },
    { src: image5, alt: "Back 4L" },
    { src: image9, alt: "Back 4L" },

];

const packageSlides = [
    { images: [image1, image2] },
    { images: [image3, image6] },
    { images: [image4, image7] },
    { images: [image5, image8] },
    { images: [image9, image10] },  // 1L
    // 20L

];

const TDS_URL = "https://www.fanfaro.de/create-pdf/141";

const SDS_FILES = [
    { code: "BE", url: "https://sct-b2b.com/out/msds/sdFF6208_-_FANFARO 6208 S-4T+ 20W-50_(BE).pdf" },
    { code: "BG", url: "https://sct-b2b.com/out/msds/sdFF6208_-_FANFARO 6208 S-4T+ 20W-50_(BG).pdf" },
    { code: "CZ", url: "https://sct-b2b.com/out/msds/sdFF6208_-_FANFARO 6208 S-4T+ 20W-50_(CZ).pdf" },
    { code: "DE", url: "https://sct-b2b.com/out/msds/sdFF6208_-_FANFARO 6208 S-4T+ 20W-50_(DE).pdf" },
    { code: "DK", url: "https://sct-b2b.com/out/msds/sdFF6208_-_FANFARO 6208 S-4T+ 20W-50_(DK).pdf" },
    { code: "EE", url: "https://sct-b2b.com/out/msds/sdFF6208_-_FANFARO 6208 S-4T+ 20W-50_(EE).pdf" },
    { code: "ES", url: "https://sct-b2b.com/out/msds/sdFF6208_-_FANFARO 6208 S-4T+ 20W-50_(ES).pdf" },
    { code: "FI", url: "https://sct-b2b.com/out/msds/sdFF6208_-_FANFARO 6208 S-4T+ 20W-50_(FI).pdf" },
    { code: "FR", url: "https://sct-b2b.com/out/msds/sdFF6208_-_FANFARO 6208 S-4T+ 20W-50_(FR).pdf" },
    { code: "GR", url: "https://sct-b2b.com/out/msds/sdFF6208_-_FANFARO 6208 S-4T+ 20W-50_(GR).pdf" },
    { code: "HR", url: "https://sct-b2b.com/out/msds/sdFF6208_-_FANFARO 6208 S-4T+ 20W-50_(HR).pdf" },
    { code: "HU", url: "https://sct-b2b.com/out/msds/sdFF6208_-_FANFARO 6208 S-4T+ 20W-50_(HU).pdf" },
    { code: "IE (EN)", url: "https://sct-b2b.com/out/msds/sdFF6208_-_FANFARO 6208 S-4T+ 20W-50_(IE).pdf" },
    { code: "IT", url: "https://sct-b2b.com/out/msds/sdFF6208_-_FANFARO 6208 S-4T+ 20W-50_(IT).pdf" },
    { code: "LT", url: "https://sct-b2b.com/out/msds/sdFF6208_-_FANFARO 6208 S-4T+ 20W-50_(LT).pdf" },
    { code: "LV", url: "https://sct-b2b.com/out/msds/sdFF6208_-_FANFARO 6208 S-4T+ 20W-50_(LV).pdf" },
    { code: "NO", url: "https://sct-b2b.com/out/msds/sdFF6208_-_FANFARO 6208 S-4T+ 20W-50_(NO).pdf" },
    { code: "PL", url: "https://sct-b2b.com/out/msds/sdFF6208_-_FANFARO 6208 S-4T+ 20W-50_(PL).pdf" },
    { code: "PT", url: "https://sct-b2b.com/out/msds/sdFF6208_-_FANFARO 6208 S-4T+ 20W-50_(PT).pdf" },
    { code: "RO", url: "https://sct-b2b.com/out/msds/sdFF6208_-_FANFARO 6208 S-4T+ 20W-50_(RO).pdf" },
    { code: "RU", url: "https://sct-b2b.com/out/msds/sdFF6208_-_FANFARO 6208 S-4T+ 20W-50_(RU).pdf" },
    { code: "SE", url: "https://sct-b2b.com/out/msds/sdFF6208_-_FANFARO 6208 S-4T+ 20W-50_(SE).pdf" },
    { code: "SI", url: "https://sct-b2b.com/out/msds/sdFF6208_-_FANFARO 6208 S-4T+ 20W-50_(SI).pdf" },
    { code: "SK", url: "https://sct-b2b.com/out/msds/sdFF6208_-_FANFARO 6208 S-4T+ 20W-50_(SK).pdf" }
];

export default function ImageWithContent() {

    const [currentIndex, setCurrentIndex] = useState(0);
    const [showModal, setShowModal] = useState(false);
    const [showSDS, setShowSDS] = useState(false);

    const [packageIndex, setPackageIndex] = useState(0);
    const [imageIndex, setImageIndex] = useState(0);

    const slideInterval = useRef(null);
    const slideDuration = 4000;

    useEffect(() => {
        startSlideTimer();
        return () => clearInterval(slideInterval.current);
    }, []);

    const startSlideTimer = () => {
        slideInterval.current = setInterval(() => {
            setCurrentIndex((prev) => (prev + 1) % images.length);
        }, slideDuration);
    };

    const goToSlide = (index) => {
        setCurrentIndex(index);
        clearInterval(slideInterval.current);
        startSlideTimer();
    };

    const nextImage = () => {
        const total = packageSlides[packageIndex].images.length;
        setImageIndex((prev) => (prev + 1) % total);
    };

    const prevImage = () => {
        const total = packageSlides[packageIndex].images.length;
        setImageIndex((prev) => (prev === 0 ? total - 1 : prev - 1));
    };

    return (
       <>
         <div
            style={{
                display: "flex",
                flexWrap: "wrap",
                alignItems: "flex-start",
                justifyContent: "center",
                gap: "32px",
                padding: "24px",
                fontFamily: "Arial",
            }}
        >

            {/* LEFT IMAGE CAROUSEL */}
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>

        {/* IMAGE CAROUSEL */}
        <div
          style={{
            position: "relative",
            width: "300px",
            height: "400px",
            borderRadius: "8px",
            overflow: "hidden",
          }}
        >
          {images.map((img, index) => (
            <img
              key={index}
              src={img.src}
              alt={img.alt}
              style={{
                width: "100%",
                height: "100%",
                objectFit: "contain",
                position: index === currentIndex ? "relative" : "absolute",
                opacity: index === currentIndex ? 1 : 0,
                transition: "opacity 1s",
              }}
            />
          ))}
        </div>
        <p
          style={{
            // marginTop: "15px",
            fontSize: "14px",
            color: "#0c0c0c",
            textAlign: "justify",
            lineHeight: "1.6",
            width:"250px",
            fontSize:"12px"
          }}
        >
          Attention! The packaging is illustrative and may differ from its actual appearance. For the latest list of specifications, see the text section.
        </p>


        
        {/* Amazon Button (external link) */}
        <a
          href="https://amzn.in/d/0gkdQGoE"
          target="_blank"
          rel="noopener noreferrer"
          style={{ textDecoration: "none" }}
        >
          <button
            style={{
              width: "150px",
              padding: "12px",
              backgroundColor: "#0d4d33",
              color: "#fff",
              border: "none",
              borderRadius: "6px",
              fontSize: "16px",
              cursor: "pointer",
            }}
          >
            Buy on Amazon
          </button>
        </a>

      </div>

            {/* RIGHT CONTENT */}
            <div style={{ paddingLeft: "30px", maxWidth: "850px" }}>
                <h2>FANFARO S-4T+ 20W-50 6208</h2>

                <p>

                    A universal all-season synthetic-based engine oil for 4-stroke normal- and high-load engines (including 2-cylinder V-type) for highway, off-road and racing motorcycles. It was designed for a guaranteed protection of the engine and the durability of the gearbox.
                </p>

                <p><strong>Product properties:</strong></p>

                <ul style={{ paddingLeft: "20px" }}>
                    <li>A special additive package and high-viscosity base ensure a high traction coefficient in friction elements, preventing wear, avoiding skidding, and providing smooth clutch operation during starting, acceleration, and driving at constant speed, enabling easy gear shifts.</li>
                    <li>Excellent lubricating, anti-wear, and anti-scuffing properties reduce fuel consumption, improve engine power, and extend service life. Provides maximum protection for the cylinder-piston group and valve gear.</li>
                    <li>Designed with a stable high-viscosity base for extreme operating conditions, offering good thermo-oxidative stability and high-temperature resistance while maintaining a strong oil film.</li>
                    <li>Maintains stable viscous properties under all operating conditions, including high sliding velocities, and ensures reliable cold starts during winter.</li>
                    <li>Special detergent-dispersion additives keep engine parts clean throughout operation.</li>
                    <li>Excellent antifoam properties and low evaporation rate.</li>
                    <li>High-performance inhibitors provide outstanding anticorrosion protection.</li>
                    <li>Compatible with analogous mineral and synthetic oils.</li>
                </ul> <br />

                <p>
                    It is designed for petrol-powered 4-stroke engines of motorcycles of all types with air and liquid cooling with or without an integrated gearbox, oil bath clutch coupling and “dry” clutch and other two-wheeled vehicles with the required operating properties of API SN or lower and JASO MA/MA2 level.
                    Comply with the manufacturer’s instructions provided in the user’s manual of the engine, especially the oil replacement age!
                </p>


                <p style={{ color: "#4CAF50", fontWeight: "bold" }}>
                    CORRESPONDS WITH REQUIREMENTS / SPECIFICATIONS / PRODUCTS:
                </p>

                {/* SPECIFICATIONS */}
                <div style={{ display: "flex", gap: "40px", flexWrap: "wrap" }}>
                    <div>
                        <b>Specifications</b>
                        <ul style={{ paddingLeft: "20px" }}>
                            <ul style={{ paddingLeft: "20px" }}>
                                <li>SAE 20W-50</li>
                                <li>API SN</li>
                                <li>JASO MA/MA2</li>
                            </ul>
                        </ul>
                    </div>


                    <div>
                        <b>Recommendation</b>
                        {/*  */}
                    </div>

                    <div>
                        <b>PACKAGES:</b>
                        <ul style={{ paddingLeft: "20px" }}>

                            <li>
                                <span
                                    style={{ cursor: "pointer" }}
                                    onClick={() => {
                                        setPackageIndex(0);
                                        setImageIndex(0);
                                        setShowModal(true);
                                    }}
                                >
                                    1L (FF6208-20)
                                </span>
                            </li>

                            <li>
                                <span
                                    style={{ cursor: "pointer" }}
                                    onClick={() => {
                                        setPackageIndex(1);
                                        setImageIndex(0);
                                        setShowModal(true);
                                    }}
                                >
                                    20L (FF6208-60)
                                </span>
                            </li>

                            <li>
                                <span
                                    style={{ cursor: "pointer" }}
                                    onClick={() => {
                                        setPackageIndex(2);
                                        setImageIndex(0);
                                        setShowModal(true);
                                    }}
                                >
                                    60L (FF6208-DR)
                                </span>
                            </li>

                            <li>
                                <span
                                    style={{ cursor: "pointer" }}
                                    onClick={() => {
                                        setPackageIndex(3);
                                        setImageIndex(0);
                                        setShowModal(true);
                                    }}
                                >
                                    208L (FF6208-IBC)
                                </span>
                            </li>

                        </ul>
                    </div>
                    <div>
                        <b>SDS & TDS</b>
                        <ul style={{ paddingLeft: "20px" }}>

                            <li>
                                
                                <a
                                    href=""
                                    onClick={(e) => {
                                        e.preventDefault();
                                        setShowSDS(true);
                                    }}
                                    style={{ textDecoration: "none", cursor: "pointer" }}
                                >
                                    📄 SDS
                                </a>
                            </li>

                            <li>
                                <a
                                    href="https://www.fanfaro.de/create-pdf/141"
                                    target="_blank"
                                    style={{ textDecoration: "none" }}>
                                    🖨️ TDS
                                </a>
                            </li>

                        </ul>
                    </div>

                </div>



            </div>

            {/* MODAL */}
            {showModal && (
                <div
                    style={{
                        position: "fixed",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                        background: "rgba(0,0,0,0.6)",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        zIndex: 999,
                    }}
                >
                    <div
                        style={{
                            background: "#fff",
                            padding: "20px",
                            width: "500px",
                            borderRadius: "8px",
                            position: "relative",
                        }}
                    >

                        <span
                            onClick={() => setShowModal(false)}
                            style={{
                                position: "absolute",
                                right: "15px",
                                top: "10px",
                                cursor: "pointer",
                                fontSize: "22px",
                            }}
                        >
                            ✕
                        </span>

                        <img
                            src={packageSlides[packageIndex].images[imageIndex]}
                            alt="package"
                            style={{
                                width: "100%",
                                maxHeight: "450px",
                                objectFit: "contain",
                            }}
                        />

                        <div style={{ textAlign: "center", marginTop: "20px" }}>

                            <button onClick={prevImage}>◀</button>

                            <span style={{ margin: "0 15px" }}>
                                {imageIndex + 1} of {packageSlides[packageIndex].images.length}
                            </span>

                            <button onClick={nextImage}>▶</button>

                        </div>

                    </div>
                </div>
            )}

            {showSDS && (
                <div className="sds-overlay" onClick={() => setShowSDS(false)}>
                    <div className="sds-modal" onClick={(e) => e.stopPropagation()}>
                        {/* Close Icon */}
                        <button
                            className="sds-close-icon"
                            onClick={() => setShowSDS(false)}
                            aria-label="Close SDS"
                        >
                            ×
                        </button>

                        <h3>Back 4L FANFARO S-4T+ 20W-50</h3>

                        <div className="sds-grid">
                            {SDS_FILES.map((file) => (
                                <a
                                    key={file.code}
                                    href={file.url}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    {file.code}
                                </a>
                            ))}
                        </div>
                    </div>
                </div>
            )}
        </div>

        <a
        href="https://wa.me/7204731100?text=Hello%20I%20need%20details"
        target="_blank"
        rel="noopener noreferrer"
        className="whatsapp-float"
      >
        <img
          src="https://cdn-icons-png.flaticon.com/512/733/733585.png"
          alt="WhatsApp"
        />
      </a>
       </>
    );
}